import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import Icon from '../Icon';

const StyledWrapperTabs = styled.div`
  display: block;
  overflow: hidden;

  ${props =>
    props.vertical &&
    css`
      position: relative;

      ${mediaqueries.greaterThan('mobile')`
        display: flex;
      `};
    `};
`;

const StyledIconPlus = styled(Icon)`
  display: block;
  height: ${rem('18px')};
  width: ${rem('18px')};
  align-self: center;

  ${props =>
    props.active &&
    css`
      display: none;
    `};

  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};
`;

const StyledIconMinus = styled(Icon)`
  display: none;
  align-self: center;
  height: ${rem('18px')};
  width: ${rem('18px')};
  z-index: 2;

  ${props =>
    props.active &&
    css`
      display: block;
    `};

  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};
`;

const StyledTitleIcon = styled.div`
  display: flex;
  justify-content: space-between;
  text-transform: uppercase;
  font-size: ${props => props.theme.fonts.small};

  &:after {
    height: calc(100% + ${rem('6px')});
    content: '';
    top: ${rem('-4px')};
    left: 0;
    position: absolute;
  }

  ${mediaqueries.lessThan('mobile')`
    padding: ${props =>
      props.wellness
        ? css`${rem('13px')}  ${rem('15px')} ${rem('13px')} ${rem('18px')}`
        : css`${rem('17px')}  ${rem('15px')} ${rem('17px')} ${rem('18px')}`};
  `};

  ${props =>
    props.active &&
    css`
      &:after {
        z-index: 1;
        background-color: ${props.wellness
          ? css`#c5d8ab`
          : `${props.theme.colors.colorThree}`};

        ${mediaqueries.greaterThan('tablet')`
          width: ${rem('180px')};
        `};

        ${mediaqueries.greaterThan('desktop')`
          width: ${rem('169px')};
        `};
      }

      ${mediaqueries.lessThan('mobile')`
        &:after {
          width:calc(100% + ${rem('4px')});
          height:${rem('56px')};
          left:${rem('-1px')};
          top:${rem('-2px')};
          z-index:1;
        }
      `};
    `};
`;

const StyledTitleTabs = styled.span`
  font-family: ${props => props.theme.fonts.bold};
  font-size: ${props => props.theme.fontSize.small};
  position: relative;
  z-index: 2;

  ${mediaqueries.greaterThan('mobile')`
    font-family: ${props => props.theme.fonts.medium};
  `};
`;

const StyledUlTabs = styled.ul`
  border-bottom: ${rem('2px')} solid ${props => props.theme.colors.grayLight};
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;

  ${mediaqueries.greaterThan('mobile')`
    border: 0;
    width: ${rem('170px')};
  `};

  ${mediaqueries.greaterThan('desktop')`
    width: ${rem('159px')};
  `};
`;

const StyledLiTab = styled.li`
  border-bottom: ${rem('1px')} solid ${props => props.theme.colors.grayLight};
  border-top: 0;
  cursor: pointer;
  display: flex;
  font-size: ${props => props.theme.fonts.small};
  justify-content: space-between;
  letter-spacing: ${rem('-0.5px')};
  line-height: ${rem('18px')};
  margin: 0;
  padding: ${rem('24px')} 1rem ${rem('24px')} ${rem('26px')};
  position: relative;
  width: 100%;

  &:before {
    content: none;
  }

  ${mediaqueries.lessThan('mobile')`
    border: ${rem('2px')} solid ${props => props.theme.colors.grayLight};
    border-bottom:0;
    display:block;
    padding:0;
  `};

  ${mediaqueries.greaterThan('tablet')`
    height: ${rem('68px')};
    display: inline-flex;
    align-items: center;
    border-right:${rem('1px')} solid ${props => props.theme.colors.grayLight};
  `};

  ${mediaqueries.greaterThan('desktop')`
    &:after {
      height: calc(100% + ${rem('6px')});
      content: '';
      top: ${rem('-4px')};
      left: 0;
      position: absolute;
      width: ${rem('169px')};
    }
    &:hover:after {
      background: ${props => props.theme.colors.grayLighter};
    }
  `};
`;

const StyleActiveContent = styled.div`
  display: none;

  ${mediaqueries.greaterThan('mobile')`
    display: block;
    width: calc(100% - ${rem('170px')});
  `};

  ${mediaqueries.greaterThan('desktop')`
    height: 100%;
    overflow-y: auto;
    width: calc(100% - ${rem('159px')});
  `};
`;

const StyleContentCollapse = styled.div`
  display: block;

  ${mediaqueries.greaterThan('mobile')`
    display: none;
  `};
`;

const StyledEffect = styled.div`
  transition: max-height 0.5s linear;
  overflow: hidden;

  ${props =>
    props.effect
      ? css`
          max-height: ${rem('600px')};
        `
      : css`
          max-height: 0;
        `};
`;

export {
  StyledWrapperTabs,
  StyledUlTabs,
  StyledLiTab,
  StyledIconPlus,
  StyledIconMinus,
  StyledTitleTabs,
  StyleActiveContent,
  StyledTitleIcon,
  StyleContentCollapse,
  StyledEffect
};
